import { Route, Routes } from 'react-router-dom';
import BlogListPage from './list';
import BlogDetailPage from './detail';
import CreateBlogPage from './create';

export default function BlogRouting() {
  return (
    <Routes>
      <Route index element={<BlogListPage />} />
      <Route path="/create" element={<CreateBlogPage />} />
      <Route path="/:id" element={<BlogDetailPage />} />
    </Routes>
  );
}
